import { IGetAllHabilidadesForHabilidadesCargosUseCase } from "../../../presentation/useCases/read/get_all_habilidades_for_habilidades_cargos_use_case";
import { HabilidadeHabilidadeCargo } from "../../models/habilidade_habilidade_cargo";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllHabilidadesForHabilidadesCargosUseCaseUseCase
 */

export class GetAllHabilidadesForHabilidadesCargosUseCase
  implements IGetAllHabilidadesForHabilidadesCargosUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getAllHabilidades(): Promise<HabilidadeHabilidadeCargo[]> {
    return await this.repository.getAllHabilidadeHabilidadeCargo();
  }
}
